export default __webpack_public_path__ + "static/DJ-Kids_Logo_Color-2202260abdf8b29b7fe58db8fede07f5.png";